'use client';

import { AuthProvider } from './AuthContext';

// This wrapper component exists solely to allow the use of AuthProvider (which relies on useEffect)
// within a Next.js server component layout (layout.tsx).
// React hooks like useEffect can only be used inside components marked with "use client".
// Since layout.tsx is an async server component, we use this client wrapper to bridge the gap.
export default function AuthProviderWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  return <AuthProvider>{children}</AuthProvider>;
}
